module.exports = __webpack_public_path__ + "img/bg.dc5f03f9.png";